import i18next from 'i18next';
import { ReactElement } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';

export interface TranslationsContextProviderProps {
	children: ReactElement;
}

export interface TranslationsContextValue {
	t: (key: string) => string;
}

export function TranslationsContextProvider({ children }: TranslationsContextProviderProps) {
	return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
}

export const useTranslationsContext = () => {
	return useTranslation();
};
